import React, {Component} from 'react';
import moment from 'moment';
import {connect} from 'react-redux';
import DatePicker from 'react-datepicker';
import {Form, Input, Select, Checkbox} from 'semantic-ui-react';
import {dateFormatPicker} from '../../../common/constants/datesFormat';
import {WARRANTIES_TYPES} from '../../constants';
import {Actions} from '../../../common/actions';
import PrincipalPart from './PrincipalPart';
import SalesPartType from './SalesPartType';
import WarrantyTabs from '../form/tabs';
import CodesPart from './CodesPart';
import CampaignPart from './CampaignPart';
import AddNewChassisModal from './modals/addNewChassisModal';
import DatePickerReadOnlyInput from '../../../common/components/form/datePickerReadOnly';
import './styles.scss';

const warrantyTypes = WARRANTIES_TYPES.filter((item) => item.text !== 'TODOS');

const AccesoriesType = (props) => {
  const {previousDate, previousKm, handleChange, disabledBtns} = props;

  return (
    <Form.Group widths='three'>
      <Form.Input fluid label='Fecha Fact Anterior'>
        <DatePicker
          customInput={<DatePickerReadOnlyInput />}
          disabled={disabledBtns}
          placeholderText='Fecha Fact Anterior'
          className='tcc-datepicker'
          showYearDropdown
          selected={previousDate ? moment(previousDate).toDate() : null}
          dateFormat={dateFormatPicker}
          onChange={(value) => handleChange('previousDate', value)}
          locale='es'
        />
      </Form.Input>
      <Form.Field
        disabled={disabledBtns}
        value={previousKm || 0}
        type='number'
        min='0'
        control={Input}
        label='Km Fac Anterior'
        placeholder='Km Fac Anterior'
        onChange={(e, {value}) => handleChange('previousKm', value)}
      />
    </Form.Group>
  );
};

const ServicePartType = (props) => {
  const {previousDate, previousKm, numPreviousOrder, handleChange, disabledBtns} = props;

  return (
    <Form.Group widths='three'>
      <Form.Input fluid label='Fecha Fact Anterior'>
        <DatePicker
          customInput={<DatePickerReadOnlyInput />}
          disabled={disabledBtns}
          placeholderText='Fecha Fact Anterior'
          className='tcc-datepicker'
          showYearDropdown
          selected={previousDate ? moment(previousDate).toDate() : null}
          dateFormat={dateFormatPicker}
          onChange={(value) => handleChange('previousDate', value)}
          locale='es'
        />
      </Form.Input>
      <Form.Field
        disabled={disabledBtns}
        value={previousKm}
        type='number'
        min='0'
        control={Input}
        label='Km Fac Anterior'
        placeholder='Km Fac Anterior'
        onChange={(e, {value}) => handleChange('previousKm', value)}
      />
      <Form.Field
        disabled={disabledBtns}
        value={numPreviousOrder}
        control={Input}
        label='No Orden Previa'
        maxLength='20'
        placeholder='No Orden Previa'
        onChange={(e, {value}) => handleChange('numPreviousOrder', value)}
      />
    </Form.Group>
  );
};

const Divisor = ({text, warranty}) => {
  return (
    <p className='warranty-divisor'>
      {text}
      {warranty && (<span>Número de garantía {warranty}</span>)}
    </p>
  );
};

class WarrantyForm extends Component {
  handleCampaignState = () => {
    const {campaignFlag, handleChange, addMessageBoxError, campaignList, chassis, vehicle} = this.props;

    if (!campaignList.length && !campaignFlag && vehicle?.chassis === chassis) {
      addMessageBoxError(`Vehículo ${chassis} no se encuentra en campaña`);
      return;
    } else if (!campaignList.length && !campaignFlag) {
      addMessageBoxError(`Vehículo ${chassis} debe ser consultado`);
      return;
    }
    handleChange('campaignFlag', !campaignFlag);
  }

  handleChassis = (e, {value}) => {
    const {vehicle, handleChange, clearCampaignsList, clearWarrantyChassis} = this.props;
    const chassisValue = value.trim();

    if (vehicle?.chassis && vehicle?.chassis !== chassisValue) {
      clearCampaignsList();
      clearWarrantyChassis();
      handleChange('campaignFlag', false);
    }
    handleChange('chassis', chassisValue);
  }

  renderTypeFields = () => {
    const {type} = this.props;
    if (type === 'AC') {
      return <AccesoriesType {...this.props} />;
    } else if (type === 'P1') {
      return <ServicePartType {...this.props} />;
    }
    return <SalesPartType {...this.props} />;
  }

  render() {
    const {dealerId, type, numTwcDealer, numFac, handleChange, orderRepairId, salesDate,
      chassis, km, repairDate, condition, cause, repair, task1, task2, observationTDE,
      observationDealer, handleChangeType, jobs, files, subcontracts, parts, totalTwc,
      principalPart, principalPartDescription, handleChangeImages, handleSearchPart,
      handleKeyDownChassis, loadingVehicle, vehicle, model, disabledBtns, stateTwc,
      evidenceFlag, campaignFlag, processDate, openRepairDate, endRepairDate, code, vehicleExists, agency,
      agencyList, handleChangeAgency} = this.props;
    const chassisError = {'content': 'Vehículo no corresponde a chassis consultado. Consulte vehículo'};

    return (
      <div className="warranty-form-pd">
        <Form>
          <Divisor text="Garantía & Vehículo" warranty={code} />
          <Form.Group widths="three">
            <Form.Field
              disabled={true}
              value={dealerId}
              control={Input}
              label="Código del Distribuidor"
              placeholder="Codigo del Distribuidor"
            />
            <Form.Field
              disabled={true}
              value={dealerId}
              control={Input}
              label="Código del Reclamante"
              placeholder="Codigo del Reclamante"
            />
            <Form.Field
              disabled={disabledBtns}
              value={agency}
              control={Select}
              options={agencyList}
              label='Agencia'
              placeholder='Agencia'
              onChange={(e, {value}) => handleChangeAgency('agency', value)}
            />
            <Form.Group widths="two">
              <Form.Field>
                <div className="field">
                  <label>Evidencia</label>
                </div>
                <Checkbox
                  toggle={true}
                  checked={evidenceFlag}
                  onChange={() => handleChange('evidenceFlag', !evidenceFlag)}
                />
              </Form.Field>
              <Form.Field>
                <div className="field">
                  <label>Campaña</label>
                </div>
                <Checkbox
                  toggle={true}
                  checked={campaignFlag}
                  disabled={
                    (!campaignFlag && vehicle?.chassis !== chassis) ||
                    disabledBtns
                  }
                  onChange={this.handleCampaignState}
                />
              </Form.Field>
            </Form.Group>
          </Form.Group>
          <Form.Group widths="three">
            <Form.Field
              disabled={disabledBtns}
              value={type}
              control={Select}
              options={warrantyTypes}
              label="Tipo TWC"
              placeholder="Tipo TWC"
              onChange={(e, {value}) => handleChangeType('type', value)}
            />
            <Form.Field
              disabled={disabledBtns}
              value={numTwcDealer}
              control={Input}
              label="Número TWC"
              maxLength="10"
              placeholder="Número TWC"
              onChange={(e, {value}) => handleChange('numTwcDealer', value)}
            />
            <Form.Field
              disabled={disabledBtns}
              value={numFac}
              control={Input}
              maxLength="10"
              label="Número de Factura"
              placeholder="Número de Factura"
              onChange={(e, {value}) => handleChange('numFac', value)}
            />
          </Form.Group>
          <Form.Group widths="three">
            <Form.Field
              disabled={disabledBtns}
              value={orderRepairId}
              control={Input}
              maxLength="8"
              label="Número de orden de reparación"
              placeholder="Número de orden de reparación"
              onChange={(e, {value}) => handleChange('orderRepairId', value)}
            />
            <Form.Field
              value={chassis}
              control={Input}
              label="VIN Chasis"
              placeholder="Chasis"
              minLength={10}
              maxLength={18}
              error={vehicle?.chassis !== chassis && chassisError}
              disabled={disabledBtns}
              loading={loadingVehicle}
              onKeyDown={handleKeyDownChassis}
              onChange={this.handleChassis}
              icon
              iconPosition="right"
            >
              <input />
              {vehicleExists === false ? (
                <AddNewChassisModal
                  chassis={chassis}
                  dealerId={dealerId}
                  addWarrantyChassis={this.props.addWarrantyChassis}
                />
              ) : null}
            </Form.Field>
            <Form.Field
              value={model || ''}
              control={Input}
              label="Modelo"
              placeholder="Modelo"
              disabled={true}
            />
          </Form.Group>
          <Form.Group widths="three">
            <Form.Input fluid label="Fecha de venta del vehículo">
              <DatePicker
                customInput={<DatePickerReadOnlyInput />}
                placeholderText="Fecha de venta del vehículo"
                className="tcc-datepicker"
                showYearDropdown
                selected={salesDate ? moment(salesDate).toDate() : null}
                disabled={loadingVehicle || disabledBtns}
                dateFormat={dateFormatPicker}
                onChange={(value) => handleChange('salesDate', value)}
                locale="es"
              />
            </Form.Input>
            <Form.Field
              disabled={disabledBtns}
              value={km}
              type="number"
              min="0"
              control={Input}
              label="Kilometraje"
              placeholder="Kilometraje"
              onChange={(e, {value}) => handleChange('km', value)}
            />
            <Form.Input fluid label="Fecha de Reparación">
              <DatePicker
                customInput={<DatePickerReadOnlyInput />}
                disabled={disabledBtns}
                placeholderText="Fecha de Reparación"
                className="tcc-datepicker"
                showYearDropdown
                selected={repairDate ? moment(repairDate).toDate() : null}
                dateFormat={dateFormatPicker}
                onChange={(value) => handleChange('repairDate', value)}
                locale="es"
              />
            </Form.Input>
          </Form.Group>

          {this.renderTypeFields()}
          <CampaignPart {...this.props} />

          <PrincipalPart
            disabledBtns={disabledBtns}
            handleChange={handleChange}
            handleSearchPart={handleSearchPart}
            principalPart={principalPart}
            principalPartDescription={principalPartDescription}
          />

          <Form.Group widths="three">
            <Form.Input fluid label="Fecha de Proceso Inicial">
              <DatePicker
                customInput={<DatePickerReadOnlyInput />}
                placeholderText="Fecha de Proceso Inicial"
                className="tcc-datepicker"
                showYearDropdown
                selected={processDate ? moment(processDate).toDate() : null}
                disabled={loadingVehicle || disabledBtns}
                dateFormat={'dd/MM/yyyy'}
                onChange={(value) => handleChange('processDate', value)}
                locale="es"
              />
            </Form.Input>
            <Form.Input fluid label="Fecha de Apertura de Reparación">
              <DatePicker
                customInput={<DatePickerReadOnlyInput />}
                placeholderText="Fecha de Apertura de Reparación"
                className="tcc-datepicker"
                showYearDropdown
                selected={
                  openRepairDate ? moment(openRepairDate).toDate() : null
                }
                disabled={loadingVehicle || disabledBtns}
                dateFormat={dateFormatPicker}
                onChange={(value) => handleChange('openRepairDate', value)}
                locale="es"
              />
            </Form.Input>
            <Form.Input fluid label="Fecha de Finalización de la Reparación">
              <DatePicker
                customInput={<DatePickerReadOnlyInput />}
                placeholderText="Fecha de Finalización de la Reparación"
                className="tcc-datepicker"
                showYearDropdown
                selected={endRepairDate ? moment(endRepairDate).toDate() : null}
                disabled={loadingVehicle || disabledBtns}
                dateFormat={dateFormatPicker}
                onChange={(value) => handleChange('endRepairDate', value)}
                locale="es"
              />
            </Form.Input>
          </Form.Group>

          <CodesPart {...this.props} />

          <Divisor text="Observaciones" />
          <Form.TextArea
            disabled={disabledBtns}
            maxLength="200"
            label="Condición"
            placeholder="Condición"
            value={condition}
            onChange={(e, {value}) => handleChange('condition', value)}
          />
          <Form.TextArea
            disabled={disabledBtns}
            maxLength="200"
            label="Causa"
            placeholder="Causa"
            value={cause}
            onChange={(e, {value}) => handleChange('cause', value)}
          />
          <Form.TextArea
            disabled={disabledBtns}
            maxLength="200"
            label="Reparación"
            placeholder="Reparación"
            value={repair}
            onChange={(e, {value}) => handleChange('repair', value)}
          />
          <Divisor text="Tareas" />
          <Form.Group widths="seven">
            <Form.Field
              control={Input}
              label="T1"
              placeholder="T1"
              value={task1}
              maxLength="2"
              disabled={disabledBtns}
              onChange={(e, {value}) => handleChange('task1', value)}
            />
            <Form.Field
              control={Input}
              label="T2"
              maxLength="2"
              placeholder="T2"
              value={task2}
              disabled={disabledBtns}
              onChange={(e, {value}) => handleChange('task2', value)}
            />
          </Form.Group>
          <WarrantyTabs
            stateTwc={stateTwc}
            disabledBtns={disabledBtns}
            totalTwc={totalTwc}
            handleChangeForm={handleChange}
            handleChangeImages={handleChangeImages}
            jobs={jobs}
            type={type}
            files={files}
            subcontracts={subcontracts}
            parts={parts}
            campaignFlag={campaignFlag}
          />
          <Divisor text="Comentarios" />
          {observationTDE && (
            <Form.TextArea
              maxLength="200"
              disabled={disabledBtns}
              label="Proveedor"
              placeholder="Proveedor"
              value={observationTDE}
              onChange={(e, {value}) => handleChange('observationTDE', value)}
            />
          )}
          <Form.TextArea
            maxLength="200"
            disabled={disabledBtns}
            label="Concesionario"
            placeholder="Concesionario"
            value={observationDealer || ''}
            onChange={(e, {value}) => handleChange('observationDealer', value)}
          />
        </Form>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'campaignList': state.campaignList.list,
    'loadingVehicle': state.warrantyVehicle.loading,
    'vehicleExists': state.warrantyVehicle.vehicleExists,
    'agencyList': state.getWarrantyAgency.agencyList,
  };
};

const {addMessageBoxError, addWarrantyChassis,
  clearCampaignsList, clearWarrantyChassis} = Actions;

export default connect(mapStateToProps, {
  addMessageBoxError,
  addWarrantyChassis,
  clearCampaignsList,
  clearWarrantyChassis,
})(WarrantyForm);
